/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import {getReportText} from 'helpers/reports-helper';
import {renderMarkdown} from 'helpers/text-helper';
import './area-page-report.scss';

const AreaPageReport = ({languageId, gameData}) => {
	const prevRound = (gameData.rounds && gameData.rounds.length > 0
		? gameData.rounds[gameData.rounds.length - 1]
		: null
	);
	const report = (prevRound && prevRound.report
		? getReportText(prevRound.report, languageId)
		: ''
	);

	return (
		<div className="AreaPageReport">
			{report.length > 0 && renderMarkdown(report)}
		</div>
	);
};


AreaPageReport.propTypes = {
	languageId: PropTypes.string.isRequired,
	gameData: PropTypes.object.isRequired
};


export default AreaPageReport;